import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M1.282 18.686 10.2 3.064c.187-.325.452-.594.767-.78A2.03 2.03 0 0 1 12 2c.362 0 .718.098 1.033.284.315.187.58.455.767.78l8.918 15.622a2.295 2.295 0 0 1 .006 2.2 2.16 2.16 0 0 1-.762.809 2.03 2.03 0 0 1-1.044.305H3.082a2.03 2.03 0 0 1-1.045-.305 2.16 2.16 0 0 1-.762-.81 2.3 2.3 0 0 1 .006-2.2M12 8.25a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0V9a.75.75 0 0 1 .75-.75M11.25 17a.75.75 0 0 1 .75-.75h.01a.75.75 0 0 1 0 1.5H12a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }